import cx from 'classnames';

import { HEADER_LAYOUT_TYPES } from '@atlas/ui';

export const getHeaderContentClassName = (
  layout,
  authenticated,
  showSignUpButton,
  isSeparateBalance,
) => {
  return cx('header-content-block', {
    'with-background':
      layout === HEADER_LAYOUT_TYPES.HEADER1 && (authenticated || !showSignUpButton),
    'with-separate-balance': isSeparateBalance,
    'with-two-buttons': !authenticated && showSignUpButton,
  });
};
